export const API_URL = process.env.VUE_APP_API_BASE_URL;
export const STORAGE_URL = process.env.VUE_APP_STORAGE_URL;